// extracted by extract-css-chunks-webpack-plugin
module.exports = {"list":"list_iN0Qu","qq":"qq_3Athx","tel":"tel_eaB1B","email":"email_4ha4v"};